/* eslint-disable jsx-a11y/anchor-is-valid */
// import clsx from 'clsx'
import {FC} from 'react'
import {useIntl} from 'react-intl'
// import {toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {Contracts} from '../../core/_models'

type Props = {
  Contracts: Contracts
}

const ContractsMeasuarement: FC<Props> = ({Contracts}) => {
  const intl = useIntl()
  return (
    <div className='d-flex text-center justify-content-center'>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 fw-semibold fs-7 mb-1'>
          {Contracts.measurement === 'yearly' &&
            intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_YEARLY'})}
          {Contracts.measurement === 'monthly' &&
            intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_MONTHLY'})}
          {Contracts.measurement === 'punctually' &&
            intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_PUNCTUALLY'})}
          {Contracts.measurement === 'yearly_monthly' &&
            intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_YEARLY_MONTHLY'})}
          {Contracts.measurement === 'free' &&
            intl.formatMessage({id: 'CONTRACTS.MEASUREMENT_FREE'})}
          {Contracts.measurement === 'not_specified' &&
            intl.formatMessage({id: 'CONTRACTS.NOT_SPECIFIED'})}
        </a>
      </div>
    </div>
  )
}
export {ContractsMeasuarement}
